// ============================================================================
// JAMB Learn Content — Economics
// Shared from WAEC learn bank (SS1+SS2+SS3 merged, no SS-level divisions shown)
// ============================================================================

import { WAEC_ECONOMICS_LEARN_SS1 } from '../../waec/learn/ss1/economics';
import { WAEC_ECONOMICS_LEARN_SS2 } from '../../waec/learn/ss2/economics';
import { WAEC_ECONOMICS_LEARN_SS3 } from '../../waec/learn/ss3/economics';

export const JAMB_LEARN_ECONOMICS = [
  ...WAEC_ECONOMICS_LEARN_SS1,
  ...WAEC_ECONOMICS_LEARN_SS2,
  ...WAEC_ECONOMICS_LEARN_SS3,
];
